import { useEffect, useRef, useState } from "react";

export async function detectLocation() {
  if (!navigator.geolocation) throw new Error("Location is not supported on this device");
  const pos = await new Promise((res, rej) => navigator.geolocation.getCurrentPosition(res, () => rej(new Error("Please allow location access")), { timeout: 10000 }));
  const { latitude, longitude } = pos.coords;
  const r = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`);
  const d = await r.json();
  return { pincode: /^\d{6}$/.test(d.postcode || "") ? d.postcode : "", city: d.city || d.locality || "", state: d.principalSubdivision || "" };
}

export function useVoice(onText) {
  const SR = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);
  const [listening, setListening] = useState(false);
  const start = () => {
    if (!SR) return;
    const rec = new SR();
    rec.lang = "en-IN";
    rec.onresult = (e) => onText(e.results[0][0].transcript);
    rec.onend = () => setListening(false);
    setListening(true);
    rec.start();
  };
  return { supported: !!SR, listening, start };
}

export function useCountUp(target, duration = 1600) {
  const ref = useRef(null);
  const [val, setVal] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      obs.disconnect();
      const t0 = performance.now();
      const step = (t) => {
        const p = Math.min((t - t0) / duration, 1);
        setVal(Math.round(target * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
    obs.observe(el);
    return () => obs.disconnect();
  }, [target, duration]);
  return [ref, val];
}
